// Navigation interne des écrans du budget (lot L4-B) : budget de l'exercice, chaîne de la dépense,
// import de la nomenclature.
import { Lien } from '@cc/ui';
import styles from './budget.module.css';

const ENTREES = [
  { id: 'budget', libelle: 'Budget de l\'exercice', href: '/budget' },
  { id: 'depense', libelle: 'Chaîne de la dépense', href: '/budget/depense' },
  { id: 'import', libelle: 'Import de la nomenclature', href: '/budget/import' },
] as const;

export function NavigationBudget({ actif }: { actif: (typeof ENTREES)[number]['id'] }) {
  return (
    <nav className={styles.navigation} aria-label="Finances et budget">
      {ENTREES.map((e) => (
        <Lien key={e.id} href={e.href} aria-current={e.id === actif ? 'page' : undefined} className={e.id === actif ? styles.lienActif : styles.lien}>
          {e.libelle}
        </Lien>
      ))}
    </nav>
  );
}
